<template>
  <two-blocks-layout :navigate="navigate" v-bind="page">
    <span class="text-outline text-title-md" v-text="`${page.titolo1} `" />
    <span class="text-title-md " v-text="page.titolo2" />
  </two-blocks-layout>
</template>
<script>
import { axios } from "@/plugins/axios";
import TwoBlocksLayout from "@/components/page-layouts/TwoBlocksLayout.vue";

export default {
  components: { TwoBlocksLayout },
  props: { navigate: { default: null } },
  async beforeRouteEnter(to, from, next) {
    let page;
    try {
      page = await axios.get(`/pageContent${to.path}.json`);
    } catch (error) {
      page = {};
    } finally {
      next(vm => (vm.page = page.data));
    }
  }
};
</script>
<route>
{
  "name": "Pagamenti digitali",
  "meta": {
      "tabOrder": 1
  }
}
</route>
